import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getVisibleHRGroup } from '../../config/hrPageGroups';
import '../../components/layout/PageGroupTabs.css'; // V70.66 renkli şerit stilleri paylaşılır

// V70.67 — İK portal sayfalarının üstünde grubun renginde yatay sekme şeridi
// (ana uygulamadaki PageGroupTabs'in İK karşılığı; aynı .pg-tabs tasarım dili)
// V71 — karar HRLayout'tan `view` ile gelir (içerik kabının .pg-grouped sınıfıyla aynı sonuç)
export default function HRGroupTabs({ view: viewProp }) {
  const { hasPermission, isAdmin } = useAuth();
  const { pathname } = useLocation();

  const view = viewProp !== undefined ? viewProp : getVisibleHRGroup(pathname, hasPermission, isAdmin);
  if (!view || !view.showTabs) return null; // tek sayfa görünüyorsa şerit gereksiz

  const { group, visible } = view;
  const [from, to] = group.color;
  return (
    <div className="pg-tabs" style={{ '--pg-from': from, '--pg-to': to }}>
      <span className="pg-tabs-label"><span className="pg-tabs-emoji">{group.emoji}</span>{group.label}</span>
      <div className="pg-tabs-scroll">
        {visible.map(i => (
          <NavLink
            key={i.to}
            to={i.to}
            className={({ isActive }) => `pg-tab${isActive || pathname.startsWith(i.to + '/') ? ' active' : ''}`}
          >
            {i.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
